export default __webpack_public_path__ + "static/media/train31.b4fefd94.png";